<template>
  <div :inert="addProductModal || showProductModal || isDeleteModal"
    aria-hidden="addProductModal || showProductModal || isDeleteModal">
    <div class="flex flex-wrap gap-3 mb-4 justify-end items-center">
      <v-select v-model="selectedCategoryId" :options="categories" label="category_name"
        :reduce="category => category.category_id" placeholder="Kategori"
        class="w-[150px] bg-primary-bg dark:bg-gray-800 rounded text-sm" />

      <button @click="createModal"
        class="bg-primary-button hover:bg-primary-button-hover text-white px-4 py-2 rounded transition-all duration-200 text-sm">
        + Yeni Ürün Ekle
      </button>
      <!-- <input type="text" placeholder="Ara..." v-model="searchQuery"
      class="h-10 w-[300px] rounded-lg border border-light-border dark:border-gray-600 bg-primary-bg dark:bg-gray-800 px-4 text-sm text-primary-text dark:text-gray-100  focus:border-indigo-500 focus:ring focus:ring-blue-100/50" /> -->
    </div>
    <div
      class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg  pb-3 shadow-md">
      <div class="w-full overflow-x-auto">
        <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
          <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
            <tr>
              <th class="px-3 md:px-6 py-2 md:py-4">Ürün Adı</th>
              <th class="px-3 md:px-6 py-2 md:py-4">Kategori</th>
              <th class="px-3 md:px-6 py-2 md:py-4">Stok</th>
              <!-- <th class="px-3 md:px-6 py-2 md:py-4">Durum</th> -->
              <th class="px-3 md:px-6 py-2 md:py-4">İşlemler</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in paginatedProducts" :key="product.id"
              class="border-b transition hover:light-hover dark:hover:dark-hover">
              <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100 ">
                {{ product.name }}
              </td>

              <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100">
                <span :class="{
                  'px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800': product.category?.category_name === 'Gübre',
                  'px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800': product.category?.category_name === 'Kömür',
                  'px-3 py-1 rounded-full text-xs font-semibold bg-gray-200 text-gray-800': !['Gübre', 'Kömür'].includes(product.category?.category_name)
                }">
                  {{ product.category?.category_name || 'Kategori Yok' }}
                </span>
              </td>


              <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100">
                {{ product.stock?.amount }} {{ product.stock?.unit?.name }}
              </td>
              <!-- <td class="px-3 md:px-6 py-2 md:py-4">
                <span :class="{
                  'px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800': product.stock?.amount > 0,
                  'px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800': product.stock?.amount === 0
                }">
                  {{ product.stock?.amount > 0 ? 'Aktif' : 'Pasif' }}
                </span>
              </td> -->
              <td class="px-3 md:px-6 py-2 md:py-4 flex gap-2">
                <button @click="editModal(product)" class="relative group">
                  <PencilSquareIcon
                    class="w-5 h-5 text-gray-500 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white" />
                  <span
                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Düzenle</span>
                </button>
                <button @click="deleteModal(product)" class="relative group">
                <TrashIcon class="w-5 h-5 text-red-500 hover:text-red-600" />
                <span
                  class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Sil</span>
              </button> 
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <AppPagination 
        :currentPage="currentPage" 
        :totalPages="totalPages" 
        :pageSize="pageSize"
        :totalItems="totalProductsCount"
        @prev-page="currentPage--"
        @next-page="currentPage++" 
        @go-to-page="page => currentPage = page"
        @update:pageSize="handlePageSizeChange"
      />
    </div>
  </div>

  <!-- Add Product Modal -->
  <div v-if="addProductModal" @click.self="addProductModal = false"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4 sm:p-0">
    <div
      class="bg-primary-bg dark:bg-primary-dark-bg p-6 sm:p-10 rounded-lg border border-light-border dark:border-dark-border w-full max-w-md sm:max-w-xl overflow-y-auto custom-scroll relative">

      <button @click="addProductModal = false"
        class="absolute top-2 right-2 p-1 text-gray-400 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white">
        <XMarkIcon class="w-6 h-6" />
      </button>

      <h2
        class="flex items-center space-x-2 text-xl font-medium mb-4 border-b border-gray-300 text-primary-text dark:text-gray-100 pb-2">
        {{ modalMode === 'edit' ? 'Ürün Güncelle' : 'Yeni Ürün Ekle' }}
      </h2>

      <form @submit.prevent="saveProduct">
        <div class="flex space-x-4 ">
          <div class="w-full">
            <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Ürün Kategori
              Seçiniz</label>

            <v-select v-model="product.category_id" :options="categories" label="category_name"
              :reduce="category => category.category_id" placeholder="Kategori Seçiniz"
              class="bg-primary-bg dark:bg-gray-800" />
          </div>

          <div class="flex items-end">
            <button @click="showProductModal = true"
              class="bg-primary-button hover:bg-primary-button-hover text-white h-10 w-10 rounded text-xl transition"
              type="button">
              +
            </button>
          </div>
        </div>

        <div class="my-4">
          <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Ürün Adı</label>
          <input v-model="product.name" type="text"
            class="w-full p-2 border rounded border-light-border dark:border-dark-border bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100" />
        </div>

 <!--         <div class="my-4">
            <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Stok Seç</label>
            <v-select v-model="product.stock_id" :options="stocks" label="name" :reduce="stock => stock.id"
              placeholder="Stok Seçiniz" class="bg-primary-bg dark:bg-gray-800 " />
          </div>  -->

        <button type="submit"
          class="w-full bg-primary-button text-white py-2 px-4 rounded hover:bg-primary-button-hover transition">
          Ürünü Kaydet
        </button>
      </form>
    </div>
  </div>

  <div v-if="showProductModal" @click.self="showProductModal = false"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
    <div
      class="bg-primary-bg dark:bg-primary-dark-bg  border border-light-border dark:border-dark-border p-6 rounded-lg w-full max-w-md relative  m-8 sm:m-0">


      <button @click="showProductModal = false"
        class="absolute top-2 right-2 p-1 text-gray-400 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white">
        <XMarkIcon class="w-6 h-6" />
      </button>

      <form @submit.prevent="saveProductCategory">
        <label class="block mb-2 text-sm font-medium text-primary-text dark:text-gray-100">Ürün Kategorisi</label>
        <input v-model="newProduct.category_name" type="text"
          class="w-full p-2 border rounded mb-4 border-light-border dark:border-dark-border bg-primary-bg dark:bg-gray-800 text-primary-text dark:text-gray-100" />

        <button type="submit"
          class="w-full bg-primary-button hover:bg-primary-button-hover text-white py-2 px-4 rounded transition">
          Ekle
        </button>
      </form>
    </div>
  </div>

  
  <DeleteModal v-if="isDeleteModal" :item="selectedProduct" message="Bu ürünü silmek istediğinizden emin misiniz?"
    @close="isDeleteModal = false" @confirm-delete="handleDelete" @click.self="isDeleteModal = false" /> 

</template>

<script>
import { getApi, postApi, putApi, deleteApi } from "@/services/api";
import DeleteModal from '@/components/Modals/DeleteModal.vue';
import vSelect from 'vue3-select'
import 'vue3-select/dist/vue3-select.css'
import { XMarkIcon, PencilSquareIcon, TrashIcon } from '@heroicons/vue/24/outline';

export default {
  name: "AllProducts",
  components: {
    PencilSquareIcon,
    DeleteModal,
    TrashIcon,
    XMarkIcon,
    vSelect,
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 50,
      totalProductsCount: 0,
      searchQuery: "",
      modalMode: 'create',
      selectedProduct: null,
      addProductModal: false,
      showProductModal: false,
      isDeleteModal: false,
      products: [],
      categories: [],
      stocks: [],
      newProduct: {
        category_id: null,
        category_name: '',
        category_status: 1,
      },
      product: {
        category_id: '',
        name: '',
        stock_id: null
      },
      selectedCategoryId: null,

    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalProductsCount / this.pageSize);
    },
    paginatedProducts() {
      const query = this.searchQuery.toLowerCase();

      if (query.trim() !== "") {
        return Array.isArray(this.products)
          ? this.products.filter(p => p.name.toLowerCase().includes(query))
          : [];
      }
      return this.products || [];
    },

  },
  async mounted() {
    this.fetchProducts();
    this.fetchCategories();
    this.fetchStocks();
  },
  methods: {
    createModal() {
      this.resetProduct();
      this.modalMode = 'create';
      this.addProductModal = true;
    },

    editModal(product) {
      this.modalMode = 'edit';
      this.selectedProduct = product;
      this.product = {
        category_id: product.category_id,
        name: product.name,
        stock_id: product.stock_id || null,
      };
      this.addProductModal = true;
    },

    deleteModal(product) {
      this.selectedProduct = product;
      this.isDeleteModal = true;
    },

    async fetchCategories() {
      try {
        this.categories = await getApi('/categories/')
      } catch (error) {
        this.$toast.error("categories çekilemedi");
      }
    },

    async fetchProducts() {
      const take = this.pageSize;
      const skip = (this.currentPage - 1) * this.pageSize;

      try {
        const response = await getApi(`/products/${take}/${skip}`, {
          category_id: this.selectedCategoryId || undefined
        });

        this.products = response.products;
        this.totalProductsCount = response.total_result;
      } catch (error) {
        this.$toast.error("Ürünler çekilemedi");
      }
    },


    async fetchStocks() {
      try {
        this.stocks = await getApi('/stocks/');
      } catch (error) {
        this.$toast.error("Stoklar çekilemedi");
      }
    },

    resetProduct() {
      this.product = {
        category_id: '',
        name: '',
        stock_id: null
      };
      this.modalMode = 'create';
      this.selectedProduct = null;
    },

    async saveProduct() {
      try {
        const payload = {
          category_id: this.product.category_id,
          name: this.product.name,
        };

        if (this.product.stock_id) {
          payload.stock_id = this.product.stock_id;
        }

        if (this.modalMode === 'edit' && this.selectedProduct?.id) {
          await putApi(`/products/${this.selectedProduct.id}`, payload);
          this.$toast.success("Ürün başarıyla güncellendi!");
        } else {
          await postApi('/products/', payload);
          this.$toast.success("Ürün başarıyla eklendi!");
        }

        this.resetProduct();
        this.fetchProducts();
        this.addProductModal = false;

      } catch (error) {
        this.$toast.error("İşlem sırasında bir hata oluştu!");
      }
    },

    handlePageSizeChange(newPageSize) {
      this.pageSize = newPageSize;
      this.currentPage = 1;
      this.fetchProducts();
    },

    async saveProductCategory() {
      try {
        await postApi('/categories/', {
          category_name: this.newProduct.category_name,
          category_status: this.newProduct.category_status,
        });

        await this.fetchCategories();
        this.showProductModal = false;
        this.newProduct = { category_name: '', category_status: 1 };

        this.$toast.success("Kategori başarıyla eklendi!");
      } catch (error) {
        this.$toast.error("Kategori eklenirken bir hata oluştu!");
      }
    },

    async handleDelete(product) {
      try {
        await deleteApi(`/products/${product.id}`);
        this.$toast.success("Ürün başarıyla silindi!");
        this.fetchProducts();
      } catch (error) {
        this.$toast.error("Silme işlemi sırasında hata oluştu!");
      } finally {
        this.isDeleteModal = false;
      }
    },

  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.fetchProducts();
    },
    currentPage() {
      this.fetchProducts();
    },
    selectedCategoryId(newVal) {
      if (newVal) {
        this.product.category_id = newVal;
      } else {
        this.product.category_id = '';
      }
      this.currentPage = 1;
      this.fetchProducts();
    },
    pageSize() {
      this.currentPage = 1;
      this.fetchProducts();
    }
  },
};
</script>
